export function boolToYN(val) {
  return val ? 'Y' : 'N';
}